/**
 * Calculate exponential backoff delay with jitter
 *
 * @param attempt - The current retry attempt number (0-indexed)
 * @param baseMs - Base delay in milliseconds (default: 1000ms)
 * @returns Calculated delay in milliseconds with jitter applied
 *
 * @example
 * // First attempt: ~1s with jitter
 * calculateExponentialBackoff(0, 1000) // ~800-1200ms
 *
 * // Fifth attempt: ~32s with jitter
 * calculateExponentialBackoff(4, 1000) // ~25600-38400ms
 */
export function calculateExponentialBackoff(attempt: number, baseMs: number = 1000): number {
  // Calculate exponential backoff: 2^attempt * baseMs (with max of 60 seconds to avoid excessive wait)
  const maxBackoff = 60 * 1000; // 60 seconds max backoff
  const exponentialTime = Math.min(Math.pow(2, attempt) * baseMs, maxBackoff);

  // Add random jitter (±20%) to avoid thundering herd problem
  const jitter = exponentialTime * 0.2;
  return exponentialTime + (Math.random() * jitter * 2 - jitter);
}
